module.exports = __webpack_public_path__ + "static/media/order.2fca986b.svg";